module.exports = __webpack_public_path__ + "78a3f46d2cdfad9b2071f6885b980aeb.svg";